import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import axios from "axios";
import { connect } from "react-redux";
import { Button } from 'reactstrap';
import { renderInput, renderTextArea, renderDatePicker } from "../common/renderinput";
import appConfig from '../../config/config';
import {Loading,LoadingDone,Reset,Success,Error,LoadPropertyMain} from "../../actions/loading";
import { CallAPI } from "../common/formsubmit";
import moment from 'moment';
class PropertyReportMain extends Component {
    constructor(...args) {
        super(...args);
    }
    componentDidMount() {

        CallAPI(
            {"OrderId":this.props.OrderId,"OrderProductId":this.props.OrderProductId},
            appConfig.apiGateway.PropertyReport,
            this.props,
            "LoadPropertyMain",
            this.props.Error,
            this.props.Error,this.props.LoadPropertyMain)
    
    }
    
    submit = (values) => {
        this.props.Loading();
        values = { ...values, EffectiveDate: moment(values.EffectiveDate).format('YYYY-MM-DDTHH:mm:ss')}
        var reqdata = JSON.stringify({
            ...values, OrderId: this.props.OrderId,
            OrderProductId: this.props.OrderProductId,
            Action: "Main",
            UserName: this.props.session.session.user.name
        });
        axios.post(
            appConfig.apiGateway.updatePropertyReport,
            reqdata,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then((response) => {
            this.props.LoadingDone();
            if (response.data.Count > 0) {
                var myObject = JSON.parse(response.data.body);
                if (myObject[0].a_out == "1") {
                    this.props.Success(myObject[0].a_message)
                }
                else {
                  this.props.Error(myObject[0].a_message)
                }
            }
        },
        (error) => {
            this.props.LoadingDone();
            this.props.Error('Unable to update')
        });
    }
    render() {
        return (
            <>
                <form onSubmit={this.props.handleSubmit(this.submit)} >
                <div className="form-row col-12 pl-0 mt-2" >
                    <div className="col-2" >
                        <Field name="SearchDate" component={renderDatePicker} label="Search Date" isLabel={true}/>
                    </div>
                    <div className="col-2">
                        <Field name="EffectiveDate" component={renderDatePicker} label="Effective Date" isLabel={true}/>
                    </div>
                    <div className="col-2" >
                        <Field name="StartDate" component={renderDatePicker} label="Search Start Date" isLabel={true}/>
                    </div>
                    <div className="col-2" >
                        <Field name="ParcelId" component={renderInput} label="ParcelId" isLabel={true}/>
                    </div>
                    <div className="col-2" >
                        <Field name="Township" component={renderInput} label="Township" isLabel={true}/>
                    </div>
                    <div className="col-2" >
                        <Field name="Liens" component={renderInput} label="No of Liens" isLabel={true}/>
                    </div>
                </div>
                <div className="form-row col-12 pl-0 " >
                    <div className="col-12" >
                        <Field name="Comments" component={renderTextArea} label="Comments" isLabel={true}/>
                    </div>
                </div>
                <div className="form-row col-12 pl-0 " >
                    <div className="col-12" >
                        <Field name="Legal" component={renderTextArea} label="Legal Description" isLabel={true}/>
                    </div>
                </div>

                <div className="col-12 pb-2 text-right">
                    <Button color="primary" type="submit" className="mr-3">Save</Button>
                    <Button type="button">Cancel</Button>
                    </div>
                </form>
            </>
        );
    }
}

const validate = (formValues) => {
    const errors = {};
    return errors;
}
var propertyReportMainForm = reduxForm({
    form: 'propertyReportMainForm',
    validate,
    enableReinitialize: true
})(PropertyReportMain);

propertyReportMainForm = connect(
    state => ({
        session: state.session,
        loading : state.loading
    }),
    {LoadingDone,LoadPropertyMain, Loading,Success,Error,Reset}
)(propertyReportMainForm);

export default propertyReportMainForm;